module.exports = __webpack_public_path__ + "static/media/list_icon_yl2.f330ebd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list_icon_yl2.svg
// module id = 195
// module chunks = 0